import ChatIllustration from "@/assets/illustrations/chat-illustration";
import React from "react";
import { Text, View } from "react-native";
import ResponsiveContent from "../shared/responsive-content";

function TutorChatEmptyState() {
  return (
    <ResponsiveContent>
      <View className="mx-4 gap-9">
        <View>
          <View className="items-center">
            <ChatIllustration />
          </View>
          <View className="bg-teachLoop-creamDark py-8 px-4 rounded-2xl">
            <Text className="font-geologica-regular font-normal text-base text-black leading-[1.5] text-center">
              New chats will appear here as soon as you get booked for a lesson
            </Text>
          </View>
        </View>
      </View>
    </ResponsiveContent>
  );
}

export default TutorChatEmptyState;
